import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const clearKittySubtractionError = () => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_SUBTRACTION_HTTP_ERROR,
      payload: {
        clear: true
      }
    });
  };
};

export const addKittySubtraction = (
  _id: string,
  subtractor_id: string,
  subtractor_type: "Other" | "User",
  amount: number,
  date: string,
  transaction_details: string,
  transaction_cost: number
) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_SUBTRACTION_HTTP_LOADING
    });

    request({
      method: "post",
      pathname: "addKittySubtraction",
      data: { _id, subtractor_id, subtractor_type, amount, date, transaction_details, transaction_cost }
    })
      .then((response) => {
        dispatch({
          type: actions.KITTY_SUBTRACTION_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.KITTY_SUBTRACTION_HTTP_ERROR, error, dispatch);
      });
  };
};

export const deleteKittySubtraction = (_id: string, subtraction_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_SUBTRACTION_HTTP_LOADING
    });

    request({ method: "post", pathname: "deleteKittySubtraction", data: { _id, subtraction_id } })
      .then((response) => {
        dispatch({
          type: actions.KITTY_SUBTRACTION_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.KITTY_SUBTRACTION_HTTP_ERROR, error, dispatch);
      });
  };
};
